import React from "react";
import { motion } from "framer-motion";
import { rankings } from "../../constants/siteContent";
import { AnimatedNumber } from "../common/AnimatedNumber";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const RankingsSection = () => {
  return (
    <section id="rankings" data-testid="rankings-section" className="py-24 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          <motion.div variants={fadeInUp} className="text-center mb-16 md:mb-[4.5rem]">
            <p className="text-[#D1111A] font-semibold tracking-[0.2em] uppercase mb-3">Where We Stand</p>
            <h2 className="font-editorial text-4xl md:text-5xl text-[#0A0A0A] italic">Kenya Football Rankings</h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 md:gap-7">
            {rankings.map((ranking) => (
              <motion.div key={ranking.label} variants={fadeInUp} className="text-center p-7 md:p-8 bg-[#F4F4F5]">
                <ranking.icon className="w-10 h-10 text-[#D1111A] mx-auto mb-4" />
                <div className="font-editorial text-6xl text-[#0A0A0A] mb-2">
                  <AnimatedNumber value={ranking.value} duration={2000} />
                  {ranking.suffix ? <span className="text-3xl">{ranking.suffix}</span> : null}
                </div>
                <p className="text-[#0A0A0A]/70 uppercase tracking-wider text-sm">{ranking.label}</p>
                {ranking.note ? <p className="text-[#D1111A] text-xs mt-2">{ranking.note}</p> : null}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};